import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const useStyles = makeStyles((theme) => ({
  contentRight: {
    width: "55%",
    paddingLeft: "30px",
  },
  tabs: {
    minHeight: "30px",
    marginBottom: "15px",
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.events.bluePrimary,
    },
  },
  tab: {
    minWidth: "0px",
    minHeight: "25px",
    fontSize: "14px",
    color: theme.palette.events.textPrimary,
    "&.Mui-selected": {
      color: theme.palette.events.bluePrimary,
    },
  },
  tabContent: {
    padding: "25px 20px",
    backgroundColor: theme.palette.gray.light,
    borderRadius: "10px",
  },
  animationContainer: {
    minHeight: "120px",
    width: "100%",
  },
  animationSvg: {
    borderRadius: "5px",
  },
}));

export default useStyles;
